import React, { Component } from "react";
import uiInfo from "../../ui-info";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import api from "../../api-axios";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  Lookup,
} from "devextreme-react/data-grid";
import ShowError from "../../AppServices";
import openReport from "../../openReport";

export default class AcompanhamentoSNBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cnpj: undefined,
      mesInicio: undefined,
      mesFinal: undefined,
      situacao: 0,
      exercicio: new Date().getFullYear(),
      bloquear: false,
      simplesNacionalRegistros: [],
      showData: false,
    };

    this.filtrar = this.filtrar.bind(this);
    this.executarProcedimentos = this.executarProcedimentos.bind(this);

    this.situacaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "TODOS" },
        { id: 1, descricao: "SEM DIFERENÇA" },
        { id: 2, descricao: "COM DIFERENÇA" },
      ],
      placeholder: "Escolher...",
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.mesOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: uiInfo.listaMeses,
      placeholder: "Escolher...",
      valueExpr: "id",
      displayExpr: "mes",
    };
  }

  render() {
    return (
      <React.Fragment>
        <div
          className={"content-block dx-card responsive-paddings"}
          style={{ padding: "30px" }}
        >
          <h3>Acompanhamento de Simples Nacional</h3>
          <form onSubmit={this.filtrar}>
            <Form formData={this.state} colCount={3} labelLocation="top">
              <SimpleItem dataField="exercicio" colSpan={1}>
                <Label text="Exercício" />
              </SimpleItem>
              <SimpleItem
                dataField="mesInicio"
                colSpan={1}
                editorOptions={{ width: "100%", useMaskBehavior: true }}
                editorType={"dxDateBox"}
              >
                <Label text="Mês início" />
              </SimpleItem>
              <SimpleItem
                dataField="mesFinal"
                colSpan={1}
                editorOptions={{ width: "100%", useMaskBehavior: true }}
                editorType={"dxDateBox"}
              >
                <Label text="Mês final" />
              </SimpleItem>
              <SimpleItem
                dataField={"cnpj"}
                colSpan={1}
                editorType={"dxTextBox"}
                editorOptions={{ mask: "00.000.000\\\\0000-00" }}
              >
                <Label text="CNPJ" />
              </SimpleItem>
              <SimpleItem
                dataField="situacao"
                colSpan={1}
                editorType={"dxLookup"}
                editorOptions={this.situacaoOptions}
              >
                <Label text="Situação" />
              </SimpleItem>
            </Form>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "50px 0px",
              }}
            >
              <Button
                width={120}
                text="Filtrar"
                type="success"
                onClick={this.filtrar}
              />
            </div>
          </form>

          <form
            onSubmit={this.executarProcedimentos}
            style={{ display: this.state.showData ? "" : "none" }}
          >
            <DataGrid
              dataSource={this.state.simplesNacionalRegistros}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
            >
              <Editing
                allowDeleting={false}
                allowUpdating={false}
                useIcons={true}
                visible={false}
              />
              <Column
                dataField={"cnpj"}
                allowEditing={false}
                caption={"CNPJ"}
              />
              <Column
                dataField={"competencia"}
                dataType={"date"}
                caption={"Competência"}
              />
              <Column dataField={"nome"} />
              <Column dataField={"valorDeclarado"} />
              <Column dataField={"valorFaturado"} />
              <Column dataField={"situacao"} caption={"Situação"}>
                <Lookup
                  dataSource={this.situacaoOptions.dataSource}
                  valueExpr={"id"}
                  displayExpr={"descricao"}
                />
              </Column>

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

              <Pager
                showInfo={true}
                showNavigationButtons={true}
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>

            <br />
            <br />
            <h3>Procedimentos</h3>

            <Form formData={this.state} colCount={4} labelLocation="top">
              <SimpleItem
                dataField="notificar"
                colSpan={1}
                editorType={"dxCheckBox"}
              >
                <Label text="Notificar" />
              </SimpleItem>
              <SimpleItem
                dataField="bloquear"
                colSpan={1}
                editorType={"dxCheckBox"}
                editorOptions={{
                  onValueChanged: (e) => this.setState({ bloquear: e.value }),
                }}
              >
                <Label text="Bloquear" />
              </SimpleItem>
              <SimpleItem
                dataField="msgBloqueio"
                colSpan={2}
                visible={this.state.bloquear}
              >
                <Label text="Mensagem de bloqueio" />
              </SimpleItem>
            </Form>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "50px 0px",
              }}
            >
              <Button
                width={200}
                text="Executar Procedimentos"
                type="success"
                onClick={this.executarProcedimentos}
              />
            </div>
          </form>
        </div>
      </React.Fragment>
    );
  }

  filtrar() {
    api
      .post("/acompanhamento_sn/buscar", this.state)
      .then((response) => {
        if (response.status === 200 && response.data) {
          this.setState({
            showData: true,
            simplesNacionalRegistros: response.data,
          });
        }
      })
      .catch((error) => {
        ShowError(error.response.data);
      });
  }

  executarProcedimentos() {
    api
      .post("/acompanhamento_sn/procedimentos", this.state)
      .then((response) => {
        if (response.status === 200 && response.data) {
          openReport(response.data);
        }
      })
      .catch((error) => {
        ShowError(error.response.data);
      });
  }
}
